import { formatterArg } from "@/helpers/currency";
import { useEventoContext } from "../../contexts/eventos";
import { useEvento } from "@/store/evento/evento";
import { useMemo } from "react";

/**
 * Componente simple que muestra una leyenda de tipos de entrada con sus precios.
 * No tiene interacción, solo visual.
 */
export function TipoEntradaLeyenda() {
    const { tipos } = useEventoContext();
    const { state: funcion } = useEvento.use.funcion();

    const entradasFuncionByTipo = useMemo(() =>
        funcion!.entradas.reduce((prev, actual) => ({
            ...prev,
            [actual.tipoEntradaId]: { ...actual }
        }), {} as Record<string, { tipoEntradaId: string; precio: number; capacidad: number }>)
        , [funcion]);

    return (
        <div className="text-white bg-white/5 backdrop-blur-sm rounded-xl p-4 flex gap-4 flex-wrap">
            {tipos.map((tipo) => {
                const actualColor = tipo.color || '#7c3aed';
                const entradaFuncion = entradasFuncionByTipo[tipo.id];
                const precio = entradaFuncion?.precio ?? 0;

                return (
                    <div key={tipo.id} className="py-3">
                        <div className="flex flex-col items-start justify-between gap-2">
                            {/* Nombre con color indicator */}
                            <div className="flex items-center gap-2">
                                <span
                                    className="w-2.5 h-2.5 rounded-full"
                                    style={{ backgroundColor: actualColor }}
                                />
                                <span className="font-semibold">{tipo.nombre}</span>
                            </div>

                            {/* Precio */}
                            <span className="text-base lg:text-lg font-medium text-white/80">
                                {formatterArg.format(precio)}
                            </span>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};
